import { CompositeLayer, CompositeLayerProps, Layer } from "@deck.gl/core"
import { PolygonLayer, TextLayer } from "@deck.gl/layers"

export type NoCoverageLayerProps = CompositeLayerProps & {
    bounds: [number, number, number, number]
}

export class NoCoverageLayer
    extends CompositeLayer<NoCoverageLayerProps>
    implements Layer<NoCoverageLayerProps>
{
    static layerName = "NoCoverageLayer"

    renderLayers(): Layer[] {
        const [west, south, east, north] = this.props.bounds
        const centerLon = (west + east) / 2
        const centerLat = (south + north) / 2

        return [
            new PolygonLayer({
                id: `${this.props.id}-fill`,
                data: [
                    [
                        [west, south],
                        [east, south],
                        [east, north],
                        [west, north],
                    ],
                ],
                getPolygon: (d) => d,
                filled: true,
                stroked: false,
                getFillColor: [80, 80, 80, 200],
                opacity: 1,
            }),
            new TextLayer({
                id: `${this.props.id}-watermark`,
                data: [{ position: [centerLon, centerLat], text: "NO DATA AVAILABLE" }],
                getPosition: (d) => d.position as [number, number],
                getText: (d) => d.text,
                getSize: 18,
                sizeUnits: "pixels",
                getColor: [255, 255, 255, 240],
                fontWeight: "bold",
                getAngle: 0,
                getTextAnchor: "middle",
                getAlignmentBaseline: "center",
                background: false,
            }),
        ]
    }
}

export const createNoCoverageLayer = (
    bounds: [number, number, number, number],
    id: string
): Layer =>
    new NoCoverageLayer({
        id,
        bounds,
    })
